import { render, staticRenderFns } from "./OrganizationNameInput.vue?vue&type=template&id=efba598e"
import script from "./OrganizationNameInput.vue?vue&type=script&lang=js"
export * from "./OrganizationNameInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports